import React, { Fragment, useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './pages/Login/Login';
import Overview from './components/main/Overview/Overview';
import Homepage from './pages/WebsitePages/Homepage';
import ServicePage from './pages/WebsitePages/ServicePage';
import AboutPage from './pages/WebsitePages/AboutPage';
import ContactUsPage from './pages/WebsitePages/ContactUsPage'
import PaymentSuccess from './components/common/PaymentSuccess';
import PaymentFailed from './components/common/PaymentFailed';
import PolicyPage from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/Terms&Conditions';

const App = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [menu, setMenu] = useState(false);
  const [IsLogin, setIsLogin] = useState<string | null>(null);
  const [inputData, setInputData] = useState({ email: '', password: '' });

  const handleResponsiveMenu = () => setMenu(false);
  const handleClickUser = () => setOpen(!open);
  const handleSidebarMemu = () => { setMenu(!menu) };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setInputData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async () => {
    try {
      const response = await axios.post('https://qbus-71fd8e240bea.herokuapp.com/api/v1/admin/login', inputData);
      const loginedUser = response?.data?.data;
      if (response.status === 200) {
        toast.success("Logined successfully")
        navigate("/booking")
        const userToken = loginedUser?.token;
        setIsLogin(userToken)
        localStorage.setItem('loginedUser', JSON.stringify(loginedUser));
        navigate('/admin/dashboard');
      }
    } catch (err) {
      toast.error('Login failed. Please check your credentials.');
      console.error(err);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('loginedUser');
    setIsLogin(null);
    navigate('/');
  };

  useEffect(() => {
    const loginedUserStr = localStorage.getItem('loginedUser');
    if (loginedUserStr) {
      const loginedUser = JSON.parse(loginedUserStr);
      const lastToken = loginedUser?.token;
      setIsLogin(lastToken);
    }
  }, []);

  // console.log("IsLogin", IsLogin)

  return (
    <Fragment>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/service" element={<ServicePage />}></Route>
        <Route path="/privacy-policy" element={<PolicyPage />}></Route>
        <Route path="/terms-condition" element={<TermsAndConditions />}></Route>
        <Route path='/about' element={<AboutPage />}></Route>
        <Route path='/contact-us' element={<ContactUsPage />}></Route>
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
        {IsLogin ? (
          <Route
            path="/admin/dashboard/*"
            element={
              <Overview
                open={open}
                handleLogout={handleLogout}
                handleClick={handleClickUser}
                menu={menu}
                handleSidebarMemu={handleSidebarMemu}
                handleResponsiveMenu={handleResponsiveMenu}
              />


            }
          />
        ) : (
          <Route
            path="/admin/login"
            element={
              <Login
                inputData={inputData}
                handleChange={handleChange}
                handleLogin={handleLogin}
              />
            }
          />
        )}
      </Routes>
      <ToastContainer />
    </Fragment>
  );
};

export default App;
